import { ConstructionNumberModel, PropertyTypeModel } from '@bpd-library/utilities';

import { isGermany } from '../is-germany';
import kebabCase from '../kebab-case';

interface FormatDetailPageUrl {
    (obj: { constructionNumber: ConstructionNumberModel }): string | undefined;
    (obj: { propertyType: PropertyTypeModel }): string | undefined;
}

/**
 * @description Takes a construction number or property type and returns the detail page url. When the object doesn't have the required data, it returns undefined.
 * @param {{
 *     constructionNumber?: ConstructionNumberModel;
 *     propertyType?: PropertyTypeModel;
 * }} {
 *     constructionNumber,
 *     propertyType,
 * }
 * @return {*}  {(string | undefined)}
 */
const formatDetailPageUrl: FormatDetailPageUrl = ({
    constructionNumber,
    propertyType,
}: {
    constructionNumber?: ConstructionNumberModel;
    propertyType?: PropertyTypeModel;
}): string | undefined => {
    const { districtHouseOverviewUrl } = window.__ENVIRONMENT_DETAILS__;

    let identifier: string | null | undefined;
    let propertyTypeName: string | null | undefined;
    let propertyTypeId: string | null | undefined;
    let districtId: string | null | undefined;

    if (constructionNumber) {
        identifier = constructionNumber.identifier;
        propertyTypeName = constructionNumber.propertyTypeName;
        propertyTypeId = constructionNumber.propertyTypeId;
        districtId = constructionNumber.districtId;
    }

    if (propertyType) {
        propertyTypeName = propertyType.name;
        propertyTypeId = propertyType.id;
        districtId = propertyType.districtId;
    }

    if (!propertyTypeName || !districtId || !propertyTypeId) return;

    propertyTypeName = encodeURI(kebabCase(propertyTypeName));
    identifier = identifier ? encodeURI(identifier) : null;

    const baseUrl = districtHouseOverviewUrl[districtId];

    if (!baseUrl) return;

    const url = isGermany()
        ? `${baseUrl}/${propertyTypeName}-objekttypen-${propertyTypeId}${identifier ? '/hausnummer-' + identifier : ''
        }`
        : `${baseUrl}/${propertyTypeName}-woningtype-${propertyTypeId}${identifier ? '/bouwnummer-' + identifier : ''
        }`;

    return url;
};

export { formatDetailPageUrl };
